import DashboardShellSkeleton from '../components/loading/DashboardShellSkeleton';

/**
 * Authentication and shell startup use the same skeleton family as lazy routes.
 */
const LoadingScreen = ({ className = '' }) => (
  <DashboardShellSkeleton pathname={window.location.pathname} className={className} />
);

export default LoadingScreen;
